function setHemisphere(hemisphere) {
  this.model.hemisphere = hemisphere;
}

export default setHemisphere;
